function get_store() {
    let host = window.location.host;

    switch (host) {
        case 'www.sonshaar.de':
        case 'sonshaar.de':
        case 'sons-de-dev-shopify.tickledchilli.co.uk':
            return 'de';
        case 'sons.ie':
        case 'store.sons.ie':
        case 'customiser-ie.sons.local':
        case 'sons-staging-ie.tickledchilli.co.uk':
        case 'sons-ie-dev-shopify.tickledchilli.co.uk':
            return 'ie';
        case 'sons.co.uk':
        case 'customiser.sons.local':
        case 'sons-dev-shopify.tickledchilli.co.uk':
            return 'uk';
        default:
            return 'uk';
    }
}

let store = get_store();
console.log(store);

$('#menu-nav').on('click', function() {
    let self = $(this);
    let body = $('body');
    let parent = self.parent().parent();
    let menuText = store === 'de' ? 'Menü' : 'Menu';
    if (parent.hasClass('active')) {
        // Close
        $('.nav__overlay').slideUp();
        self.parent().parent().removeClass('active');
        body.removeClass('stop-scroll');
        self.find('.desktop').text(menuText);
        if ($(window).width() < 992) {
            let burger = $('#burger');
            let burgerTop = $('#burgerTop');
            let burgerCenter = $('#burgerCenter');
            let burgerBottom = $('#burgerBottom');
            if (burgerTop.hasClass('burgerLineTopAnimation')) {
                burgerTop.removeClass('burgerLineTopAnimation');
                burgerCenter.removeClass('burgerLineCenterAnimation');
                burgerBottom.removeClass('burgerLineBottomAnimation');
                burger.removeClass('open-burger');
            }
        }
    } else {
        // Open
        let menuText = store === 'de' ? 'Schließen' : 'Close';
        $('.nav__overlay').slideDown();
        self.parent().parent().addClass('active');
        body.addClass('stop-scroll');
        self.find('.desktop').text(menuText);
        if ($(window).width() < 992) {
            let burger = $('#burger');
            let burgerTop = $('#burgerTop');
            let burgerCenter = $('#burgerCenter');
            let burgerBottom = $('#burgerBottom');
            if (!burgerTop.hasClass('burgerLineTopAnimation')) {
                burgerTop.addClass('burgerLineTopAnimation');
                burgerCenter.addClass('burgerLineCenterAnimation');
                burgerBottom.addClass('burgerLineBottomAnimation');
                burger.addClass('open-burger');
            }
        }
    }
});

$(window).on('resize', function() {
    let burger = $('#burger');
    if ( $(window).width() <= 991 && $('.nav__menu').hasClass('active') && !burger.hasClass('open-burger') ) {
       let burgerTop = $('#burgerTop');
       let burgerCenter = $('#burgerCenter');
       let burgerBottom = $('#burgerBottom');
        if (!burgerTop.hasClass('burgerLineTopAnimation')) {
            burgerTop.addClass('burgerLineTopAnimation');
            burgerCenter.addClass('burgerLineCenterAnimation');
            burgerBottom.addClass('burgerLineBottomAnimation');
            burger.addClass('open-burger');
        }
   }
});

$('.links__main a').hover( function(){
    if ($(window).width() >= 992) {
        let self = $(this).parent();
        let imageContainer = $('.overlay__image');
        let linkClasses = self.attr('class');
        linkClasses = linkClasses.replace('links__main', '');
        linkClasses = linkClasses.trim();
        if (linkClasses !== "xxm_log_outxx") {
            imageContainer.removeAttr('class');
            imageContainer.attr('class', 'overlay__image');
            if (linkClasses.length > 0 && linkClasses.startsWith('m_')) {
                imageContainer.addClass(linkClasses);
            } else {
                imageContainer.addClass("contact");
            }
        }

    }
});
